// extracted by mini-css-extract-plugin
module.exports = {"className":"Panel--className"};